<template>
    <div>
        <streaming-write-link v-for="writeLayout in writeLayouts" :key="`streamingComp${writeLayout}`"
                              :writeLayout="writeLayout" :streamingData="streamingData"
                              :optionData="optionData"></streaming-write-link>
    </div>
</template>

<script>
import StreamingWriteLink from "@/components/streaming/StreamingWriteLink";
import streamingUtil from "@/components/streaming/streamingUtil";
import util from "@/mixins/util";
import alertMixins from "@/mixins/alertMixins";
import elFileMixins from "@/mixins/elFileMixins";
import EventBus from "@/utils/event-bus";
import streamingValidator from "@/mixins/validators/streamingValidator";
import DeleteClass from "@/mixins/deleteClass";

export default {
    name: "StreamingWriteComponent",
    mixins: [streamingUtil, alertMixins, elFileMixins, streamingValidator],
    components: {StreamingWriteLink},
    provide() {
        return {
            streamingWriteSetData: this.setData,
        }
    },
    props: {
        streamingType: {default: ''},
        streamingKey: {default: 0},
        liveKlassKey: {default: ''},
    },
    data() {
        return {
            writeLayouts: [],
            getFunc: '',
            detailApiParamsSet: {},
            getDetailParamsKey: '',
            writeFunc: '',
            writeApiParamSet: {},
            parsingData: {},
            directUrl: '',
            directType: '',
            keyName: '',
            writeSuccessType: 1,
            writeFailTypes: {},
            fileType: '',
            isRunning: false,
            streamingData: {},
            optionData: [],
            selectedImageOption: {},
            validityData: {},
            imageOptionDeleteClass: null,
            vimeoPlugin: null,
            bookListUse: false,

        }
    },
    created() {
        this.initFilterConfig();
        if (this.streamingKey != 0) {
            this.getStreaming();
        } else {
            this.initLayoutConfig();
        }

    },
    mounted() {
        EventBus.$on('writeStreaming', this.writeStreaming);
        EventBus.$on('removeStreaming', this.runDeleteConfirm);
    },
    beforeDestroy() {
        EventBus.$off('writeStreaming')
        EventBus.$off('removeStreaming')
    },
    destroyed() {
    },
    computed: {},
    methods: {
        setData(type, value) {
            this[type] = value;
        },
        initLayoutConfig() {
            let config = this.returnStreamingConfig(this.streamingType);
            this.writeLayouts = config.writeLayouts;
        },
        initFilterConfig() {
            let config = this.returnStreamingConfig(this.streamingType);
            this.getCategoryFunc = config.getCategoryFunc;
            this.categoryApiParamsSet = config.categoryApiParamsSet;
            this.getFunc = config.getFunc;
            this.detailApiParamsSet = config.detailApiParamsSet;
            this.getDetailParamsKey = config.getDetailParamsKey;
            this.writeFunc = config.writeFunc;
            this.writeApiParamSet = config.writeApiParamSet;
            this.parsingData = config.parsingData;
            this.directUrl = config.directUrl;
            this.directType = config.directType;
            this.fileType = config.fileType;
            this.keyName = config.keyName;
            this.writeSuccessType = config.writeSuccessType;
            this.writeFailTypes = config.writeFailTypes;
            this.validityData = config.validityData;

            this.deleteFunc = config.deleteFunc;
            this.deleteApiParamsSet = config.deleteApiParamsSet;
            this.deleteSuccessType = config.deleteSuccessType;
            this.deleteFailTypes = config.deleteFailTypes;

            this.newDeleteClass();
        },

        getStreaming() {
            let params = JSON.parse(JSON.stringify(this.detailApiParamsSet));
            params[this.getDetailParamsKey] = this.streamingKey;
            this.$api.$streaming[this.getFunc](params).then(res => res.Data.Result).then(res => {
                if (res.Info.type != 1 || util.isEmpty(res.List)) {
                    this.createAlert({
                        title: '',
                        content: '데이터를 불러올 수 없습니다.',
                        btnText: '확인',
                        hide: () => {
                            this.$router.back();
                        }
                    });
                    return;
                }
                this.streamingData = res.List[0];
                EventBus.$emit("setStreamingStatus",this.streamingData.s_status);
                this.initLayoutConfig();
            })
        },
        _checkValidator() {
            let validatorArr = Object.keys(this.validityData);
            console.log(validatorArr);
            return this.$validate(validatorArr).then(success => {
                if (!success) {
                    this.errorAlert('필수데이터를 확인해주세요.')
                    util.Array.each(this.writeLayouts, (layout, index, arr) => {
                        EventBus.$emit(`${layout}Validator`, validatorArr);
                    });
                    return success
                }
                return success;
            })
        },
        _makeParams() {
            let params = Object.assign({}, this.writeApiParamSet);
            util.Object.each(this.parsingData, (dataKey, paramKey, obj) => {
                params[paramKey] = this[dataKey];
            })
            if (this.streamingKey !== 0) {
                params[this.keyName] = this.streamingKey;

            }
            return params;
        },
        async writeStreaming(statusChange) {
            if (this.isRunning) return false;
            this.changeLoading(true);
            let validator = await this._checkValidator();
            if (!validator) {
                this.changeLoading(false);
                return false;
            }
            let params = this._makeParams();
            if (this.liveKlassKey !== '' && !statusChange) {
                params['lk_idx'] = this.liveKlassKey;
            }
            if (statusChange) {
                params = {};
                params['s_idx'] = this.streamingKey;
                params['s_status'] = 2;
            }
            try {
                this.$api.$streaming[this.writeFunc](params).then(res => res.Data.Result).then(res => {
                    let type = this.returnWriteType(res.Info.type);
                    if (type != true) {
                        this.errorAlert(type);
                        this.changeLoading(false);
                        return false;
                    }
                    this.uploadFiles(this.liveFiles, 'streaming_live', res.List).then(success => {
                        this.uploadFiles(this.listFiles, 'streaming_list', res.List).then(success => {
                            this.createChatRoom();
                            this.changeLoading(false);
                            this.afterFunc(res.List);
                        });
                    });
                })
            } catch (e) {
                this.changeLoading(false);
                console.log(e)
            }
        },
        changeLoading(value) {
            this.isRunning = value;
            EventBus.$emit('apiLoading', value);
        },
        createChatRoom() {
            if (this.streamingKey != 0) {
                let roomId = this.streamingData.s_uuid;
                let roomRef = this.$store.state.db.collection("rooms");
                let convoRef = roomRef.doc(roomId);
                convoRef.get().then(function (doc) {
                    if (!doc.data()) {
                        let roomData = {
                            created: Date.now(),
                            updated: Date.now(),
                            id: roomId,
                            msg: {lastMsg: '', lastName: '', created: '', lastImg: '',},
                            roomType: "liveChat",
                            isQuickRequesting: false,
                        };
                        roomRef.doc(roomId).set(roomData, {merge: true})
                            .then(function (res) {
                                console.log("라이브 챗 생성 완료");
                            })
                            .catch(function (error) {
                                console.log("라이브 챗 생성 오류");
                            });
                    }
                })
            }
        },
        returnWriteType(type) {
            if (type == this.writeSuccessType) {
                return true;
            } else {
                return util.isEmpty(this.writeFailTypes[type]) ? '저장에 실패하였습니다.' : this.writeFailTypes[type]
            }
        },
        afterFunc(key) {
            let detailKey = key;
            this.createAlert({
                title: '',
                content: '저장되었습니다.',
                btnText: '확인',
                hide: () => {
                    if (this.directType === 'back') {
                        this.$router.back();
                        return false;
                    }
                    if (this.directUrl === '') {
                        this.writeLayouts = [];
                        this.deleteFiles = [];
                        this.getContent();
                        return false;
                    }
                    let url = this.directUrl;
                    if (this.directType === 'detail') {
                        url = url + detailKey;
                    }
                    this.$router.push(url);
                }
            })
        },
        newDeleteClass() {
            let deleteOptions = {
                func: this.$api.$streaming[this.deleteFunc],
                apiParamSet: this.deleteApiParamsSet,
                keyName: this.keyName,
                successType: this.deleteSuccessType,
                errorTypes: this.deleteFailTypes,
                afterFunc: this.deleteAfterFunc,
            }
            this.DeleteClass = new DeleteClass(deleteOptions);
        },
        runDeleteConfirm() {
            if (this.streamingKey === 0) {
                this.errorAlert('스트리밍 상세만 삭제할 수 있습니다.');
                return false;
            }
            this.createConfirm({
                content: '스트리밍을 삭제하시겠습니까? <br>삭제시 복구 불가하며 앱에서도 삭제 처리되니 유의바랍니다.',
                confirmButtonText:"삭제",
                confirm: () => {
                    this.runDelete();
                }
            })
        },
        runDelete() {
            EventBus.$emit('apiLoading', true);
            this.DeleteClass.runDelete(this.streamingKey);
        },
        deleteAfterFunc() {
            EventBus.$emit('apiLoading', false);
            this.createAlert({
                content: '삭제되었습니다.',
                hide: () => {
                    this.$router.push(`/content/liveklass/${this.liveKlassKey}/streaming`);
                }
            })
        },
    },
    watch: {},
}
</script>

<style scoped>

</style>
